<template>
  <div class="row">
    <div v-if="readingFromBle" class="loading-overlay">
      <LoadingPlaceholder/>
    </div>
    <div class="col-12 d-flex justify--space-between clickable">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
      <i v-if="isBleAvailable" class="fa fa-bluetooth" style="font-size: 30px; color: #223fb9"
         @click="handleBluetoothRead"></i>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="1000"
          min="0.01"
          :error="errors.durationSession.length > 0"
          :error-messages="errors.durationSession"
          v-model="measuresFromBle && form.durationSession !== null ? form.durationSession.toFixed(3) : form.durationSession"
          :placeholder="$t('dashboard_new_evollu.measurement_types.duration_session_short')+' (min)'"
          :label="$t('dashboard_new_evollu.measurement_types.duration_session_short')+' (min)'"
          required
          :v-bind:class="{'error': true}"
          :disabled="measuresFromBle"
        />
      </div>
    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group" v-if="measuresFromBle">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.oximetryMax.length > 0"
          :error-messages="errors.oximetryMax"
          v-model="form.oximetryMax"
          :placeholder="$t('dashboard_new_evollu.measurement_types.oximetry_max_short')+' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.oximetry_max_short')+' (%)'"
          required
          :disabled="measuresFromBle"
        />
      </div>
      <div class="col-6 form-group" v-if="measuresFromBle">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.oximetryMin.length > 0"
          :error-messages="errors.oximetryMin"
          v-model="form.oximetryMin"
          :placeholder="$t('dashboard_new_evollu.measurement_types.oximetry_min_short')+' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.oximetry_min_short')+' (%)'"
          required
          :disabled="measuresFromBle"
        />
      </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.oximetryAvg.length > 0"
          :error-messages="errors.oximetryAvg"
          v-model="form.oximetryAvg"
          :placeholder="$t('dashboard_new_evollu.measurement_types.oximetry_avg_short')+' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.oximetry_avg_short')+' (%)'"
          required
          :disabled="measuresFromBle"
        />
      </div>
      <div class="col-6 form-group" v-if="measuresFromBle">
        <va-input
          type="number"
          step="0.1"
          max="300"
          min="0"
          :error="errors.pulseRateMax.length > 0"
          :error-messages="errors.pulseRateMax"
          v-model="form.pulseRateMax"
          :placeholder="$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short')+' (bpm)'"
          :label="$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short')"
          required
          :disabled="measuresFromBle"
        />
      </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group" v-if="measuresFromBle">
        <va-input
          type="number"
          step="0.1"
          max="300"
          min="0"
          :error="errors.pulseRateMin.length > 0"
          :error-messages="errors.pulseRateMin"
          v-model="form.pulseRateMin"
          :placeholder="$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short')+' (bpm)'"
          :label="$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short')"
          required
          :disabled="measuresFromBle"
        />
      </div>
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="300"
          min="0"
          :error="errors.pulseRateAvg.length > 0"
          :error-messages="errors.pulseRateAvg"
          v-model="form.pulseRateAvg"
          :placeholder="$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short')+' (bpm)'"
          :label="$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short')+' (bpm)'"
          required
          :disabled="measuresFromBle"
        />
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import HandleBluetoothMixin
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/HandleBluetoothMixin.vue";

const DURATION_MONITORING_SESSION_TYPE_ID = 46
const OXIMETRY_MAX_TYPE_ID = 47
const OXIMETRY_MIN_TYPE_ID = 48
const OXIMETRY_AVG_TYPE_ID = 49
const PULSE_RATE_MAX_TYPE_ID = 50
const PULSE_RATE_MIN_TYPE_ID = 51
const PULSE_RATE_AVG_TYPE_ID = 52
export default {
  components: {LoadingPlaceholder},
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  mixins: [
    HandleBluetoothMixin
  ],
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        durationSession: null,
        oximetryMax: null,
        oximetryMin: null,
        oximetryAvg: null,
        pulseRateMax: null,
        pulseRateMin: null,
        pulseRateAvg: null
      },
      errors: {
        durationSession: [],
        oximetryMax: [],
        oximetryMin: [],
        oximetryAvg: [],
        pulseRateMax: [],
        pulseRateMin: [],
        pulseRateAvg: []
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 18
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = false
      if(this.measuresFromBle) {
        canSubmit = (this.form.durationSession !== null && this.form.durationSession !== '') &&
          (this.form.oximetryMax !== null && this.form.oximetryMax !== '') &&
          (this.form.oximetryMin !== null && this.form.oximetryMin !== '') &&
          (this.form.oximetryAvg !== null && this.form.oximetryAvg !== '') &&
          (this.form.pulseRateMax !== null && this.form.pulseRateMax !== '') &&
          (this.form.pulseRateMin !== null && this.form.pulseRateMin !== '') &&
          (this.form.pulseRateAvg !== null && this.form.pulseRateAvg !== '')
      } else {
        canSubmit = (this.form.durationSession !== null && this.form.durationSession !== '') &&
          (this.form.oximetryAvg !== null && this.form.oximetryAvg !== '') &&
          (this.form.pulseRateAvg !== null && this.form.pulseRateAvg !== '')
      }

      this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.durationSession": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 0.01 || value > 1000)) {
        this.errors.durationSession = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 0.01,
          max: 1000
        })]
      } else {
        this.errors.durationSession = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === DURATION_MONITORING_SESSION_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === DURATION_MONITORING_SESSION_TYPE_ID)
        elem.value = this.errors.durationSession.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.durationSession.length === 0 ? value : null,
          typeId: DURATION_MONITORING_SESSION_TYPE_ID
        })
      }
    },
    "form.oximetryMax": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 1 || value > 100)) {
        this.errors.oximetryMax = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 1,
          max: 100
        })]
      } else {
        this.errors.oximetryMax = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === OXIMETRY_MAX_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === OXIMETRY_MAX_TYPE_ID)
        elem.value = this.errors.oximetryMax.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.oximetryMax.length === 0 ? value : null,
          typeId: OXIMETRY_MAX_TYPE_ID
        })
      }
    },
    "form.oximetryMin": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 1 || value > 300)) {
        this.errors.oximetryMin = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 1,
          max: 100
        })]
      } else {
        this.errors.oximetryMin = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === OXIMETRY_MIN_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === OXIMETRY_MIN_TYPE_ID)
        elem.value = this.errors.oximetryMin.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.oximetryMin.length === 0 ? value : null,
          typeId: OXIMETRY_MIN_TYPE_ID
        })
      }
    },
    "form.oximetryAvg": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 1 || value > 100)) {
        this.errors.oximetryAvg = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 1,
          max: 100
        })]
      } else {
        this.errors.oximetryAvg = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === OXIMETRY_AVG_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === OXIMETRY_AVG_TYPE_ID)
        elem.value = this.errors.oximetryAvg.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.oximetryAvg.length === 0 ? value : null,
          typeId: OXIMETRY_AVG_TYPE_ID
        })
      }
    },
    "form.pulseRateMax": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 1 || value > 300)) {
        this.errors.pulseRateMax = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 1,
          max: 300
        })]
      } else {
        this.errors.pulseRateMax = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === PULSE_RATE_MAX_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === PULSE_RATE_MAX_TYPE_ID)
        elem.value = this.errors.pulseRateMax.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.pulseRateMax.length === 0 ? value : null,
          typeId: PULSE_RATE_MAX_TYPE_ID
        })
      }
    },
    "form.pulseRateMin": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 1 || value > 300)) {
        this.errors.pulseRateMin = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 1,
          max: 300
        })]
      } else {
        this.errors.pulseRateMin = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === PULSE_RATE_MIN_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === PULSE_RATE_MIN_TYPE_ID)
        elem.value = this.errors.pulseRateMin.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.pulseRateMin.length === 0 ? value : null,
          typeId: PULSE_RATE_MIN_TYPE_ID
        })
      }
    },
    "form.pulseRateAvg": function (value) {
      this.checkCanSubmit()
      if (value !== '' && (value < 1 || value > 300)) {
        this.errors.pulseRateAvg = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {
          min: 1,
          max: 300
        })]
      } else {
        this.errors.pulseRateAvg = []
      }

      if (this.measurement.measurements.find(meas => meas.typeId === PULSE_RATE_AVG_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === PULSE_RATE_AVG_TYPE_ID)
        elem.value = this.errors.pulseRateAvg.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.pulseRateAvg.length === 0 ? value : null,
          typeId: PULSE_RATE_AVG_TYPE_ID
        })
      }
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
